module.exports = __webpack_public_path__ + "img/3_fineTeam_zsb.9b634a4f.png";